/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReferralLedgerEntryDto,
    ReferralLedgerEntryDtoFromJSON,
    ReferralLedgerEntryDtoFromJSONTyped,
    ReferralLedgerEntryDtoToJSON,
} from './ReferralLedgerEntryDto';

/**
 * 
 * @export
 * @interface ReferralLedgerDto
 */
export interface ReferralLedgerDto {
    /**
     * 
     * @type {number}
     * @memberof ReferralLedgerDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralLedgerDto
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralLedgerDto
     */
    offset: number;
    /**
     * 
     * @type {Array<ReferralLedgerEntryDto>}
     * @memberof ReferralLedgerDto
     */
    items: Array<ReferralLedgerEntryDto>;
}

export function ReferralLedgerDtoFromJSON(json: any): ReferralLedgerDto {
    return ReferralLedgerDtoFromJSONTyped(json, false);
}

export function ReferralLedgerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralLedgerDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'limit': json['limit'],
        'offset': json['offset'],
        'items': ((json['items'] as Array<any>).map(ReferralLedgerEntryDtoFromJSON)),
    };
}

export function ReferralLedgerDtoToJSON(value?: ReferralLedgerDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'limit': value.limit,
        'offset': value.offset,
        'items': ((value.items as Array<any>).map(ReferralLedgerEntryDtoToJSON)),
    };
}

